<template>

  <div class="page-wrap">

    <Header></Header>

    <div class="content">

      <div class="title-text">
        <span>文档验签</span>
        <span style="padding-left: 12px; font-size: 12px">上传完成电子签署的文件，检测文件是否被篡改</span>
      </div>

      <el-card class="box-card" v-loading="loading">
        <file-upload
            ref="upload"
            :loading.sync="loading"
            :resultList.sync="resultList"
            :fileType="['ofd','pdf']"
        />
      </el-card>

      <!--      :type=" resultList.result == 'true' ? 'success' : 'error'"-->
      <el-alert
          v-if="resultList.msg"
          style="
            margin: 0 auto 24px;
            min-width: 768px;
            max-width: 1040px;"
          :title="resultList.msg"
          type="success"
          :closable="false">
      </el-alert>

      <el-card class="box-card result " v-if="resultList.result == 'true'" v-for="item in resultList.signedInfo"
               :key="item.ownerId">
        <div>{{ item.eseal ? item.eseal.name : '' }} 验证通过</div>
        <div>该签章有效，受该签章保护的内容未被修改</div>

        <el-divider></el-divider>

        <div class="flex-center-between" style="width: 100%">
          <div class="flex-dir-start-between">
            <div v-if="item.eseal">签章人：{{ item.eseal ? item.eseal.esID : '' }}</div>
            <div>签章时间：{{ item.signedDate }}</div>
          </div>
          <div>
            <el-button type="primary" size="small" @click="openCertificate(item)">签章人证书</el-button>
          </div>
        </div>

        <el-divider></el-divider>

        <div class="flex-center-between" style="width: 100%">
          <div class="flex-dir-start-between">
            <div v-if="item.eseal">印章名称：{{ item.eseal ? item.eseal.name : '' }}</div>
            <div>有效起止日：{{ item.cert.notBefore }} 到 {{ item.cert.notAfter }}</div>
          </div>
          <div>
            <el-button type="primary" size="small" @click="openSignature(item)">电子签章信息</el-button>
          </div>
        </div>
      </el-card>
    </div>

    <Bottom></Bottom>

    <certificate-information
        v-if="certificateVisible"
        :visible.sync="certificateVisible"
        :signedInfo="signedInfo"
    />

    <signature-information
        v-if="signatureVisible"
        :visible.sync="signatureVisible"
        :signedInfo="signedInfo"
    />

  </div>

</template>

<script>
import Header from "@/components/Header.vue";
import Bottom from "@/components/Bottom.vue";
import CertificateInformation from "@/pages/verifyTruth/components/certificateInformation.vue";
import SignatureInformation from "@/pages/verifyTruth/components/signatureInformation.vue";

export default {
  name: "index",
  components: {SignatureInformation, CertificateInformation, Bottom, Header},
  data() {
    return {
      loading: false,
      resultList: {},
      signedInfo: {},

      certificateVisible: false,
      signatureVisible: false,
    }
  },
  methods: {
    openCertificate(item) {
      this.signedInfo = item
      this.certificateVisible = true
    },
    openSignature(item) {
      this.signedInfo = item
      this.signatureVisible = true
    },

  }
}
</script>

<style scoped lang="less">

.content {
  height: calc(100vh - 104px);
  padding: 20px 30px;
  min-height: 778px;
  background: #f5f7fa;
}

.title-text {
  flex: auto;
  font-weight: 500;
  font-size: 24px;
  color: #2c4fa5;
  text-align: center;
  min-width: 768px;
  max-width: 1040px;
  margin: 0 auto 24px
}

.box-card {
  min-width: 768px;
  max-width: 1040px;
  margin: 0 auto 24px;
}

.result ::v-deep .el-card__body {
  padding: 20px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

</style>
